import { generatePath } from "react-router-dom";
import { apiRoutes } from "../apiRoutes";
import axios from "../appAxios";

export const likeReview = async (reviewId) => {
  const response = await axios.post(generatePath(apiRoutes.LIKE_REVIEW, { reviewId }));
  return response.data;
};

export const unlikeReview = async (reviewId) => {
  const response = await axios.delete(generatePath(apiRoutes.LIKE_REVIEW, { reviewId }));
  return response.data;
};
